import { errorHandlingModals } from '../defaultErrorHandlingComponents';
import { type ErrorHandlingComponent, type RetryFunction } from '../FrontRoyalErrorBoundary.types';
import angularModule from './frontRoyalErrorBoundaryModule';

type ErrorHandlers = Record<keyof typeof errorHandlingModals, ErrorHandlingComponent>;
type Scope = angular.IScope &
    ErrorHandlers & {
        onErrorResolved: () => void;
        retry: RetryFunction;
    };

angularModule.directive('showErrorModal', [
    '$injector',

    function factory() {
        return {
            restrict: 'E',
            template: `
                <front-royal-error-boundary-react-component
                    error="error"
                    reset-error-boundary="onErrorResolved"
                    retry="retry"
                    other="other"
                    disconnected="disconnected"
                    not-logged-in="notLoggedIn"
                    not-permitted="notPermitted"
                ></front-royal-error-boundary-react-component>
            `,
            scope: {
                error: '<',
                defaultErrorActions: '<',
                onErrorResolved: '<',
                retry: '<',
            },
            link(scope: Scope) {
                // This is defined in a bit of an odd way, but it makes it so that if another
                // option is added to topLevelErrorActions, it will trigger a typescript error here.
                // Hopefully this helps us to remember that we have to add it to the template above.
                const handledErrorTypes: ErrorHandlers = {
                    other: errorHandlingModals.other,
                    disconnected: errorHandlingModals.disconnected,
                    notLoggedIn: errorHandlingModals.notLoggedIn,
                    notPermitted: errorHandlingModals.notPermitted,
                };
                Object.keys(handledErrorTypes).forEach(key => {
                    const errorType = key as keyof ErrorHandlers;
                    scope[errorType] = handledErrorTypes[errorType];
                });
            },
        };
    },
]);
